import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { ThumbnailsComponent } from '@rx-lib/ui';
import { map, tap } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { RxFor } from '@rx-angular/template/for';
import { RxLet } from '@rx-angular/template/let'
import { Observable } from 'rxjs';
import { RouteMapEntry } from '@rx-lib/models';

@Component({
  selector: 'lib-projects',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RxLet, RxFor, ThumbnailsComponent],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsComponent {

  private currentRoute$: Observable<RouteMapEntry> = inject(ActivatedRoute).snapshot.data['currentRoute'];

  readonly project$ = this.currentRoute$.pipe(
    // tap((currentRoute) => console.log('ProjectsComponent currentRoute ', currentRoute)),
    map((currentRoute) => currentRoute.page),
    take(1)
  );

  readonly thumbnails$ = this.currentRoute$.pipe(
    tap((currentRoute) => console.log('ProjectsComponent currentRoute ', currentRoute)),
    map((currentRoute) => currentRoute.page.media.map((subPage, index) => ({
      title: currentRoute.page.title + ' ' + ( index + 1 ),
      url: currentRoute.page.path + '/' + ( index + 1 ),
      image: subPage.media_image,
      video: subPage.media_video_file
    }))),
    take(1)
  );

  readonly index$ = this.currentRoute$.pipe(
    // tap((currentRoute) => console.log('ProjectsComponent currentRoute ', currentRoute)),
    map((currentRoute) => currentRoute.subIndex)
  );


}
